import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { ToggleSwitch } from '../../../components/common/inputs/ToggleSwitch';
import { usePutUsersMeMutation } from '../../../hooks/api/user/mutations/usePutUsersMe.mutation';
import { usePopup } from '../../../hooks/popup/usePopup';
import { useLayout } from '../../../hooks/screen/useLayout';
import { useGetUserProfile } from '../../../hooks/user/useGetUserProfile';
import { postMessageToRN } from '../../../utils/RNCommunicator/postMessageToRN.util';
import { setRNMessageReceiver } from '../../../utils/RNCommunicator/setRNMessageReceiver.util';
import { formatDate } from '../../../utils/formatter/formatDate.util';
import { useNotification } from '../../../provider/ToastNotificationProvider';

export const MyInfoAlarmSettingPage = () => {
  const { userProfile } = useGetUserProfile();
  const { mutate: putUsersMe } = usePutUsersMeMutation();
  const { openNotification } = useNotification();

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} headerTitle={'알람 설정'} />,
    fixedHeaderHeight: 40,
  });

  const requestPushAlarmPermission = () => {
    const onMessageHandler = async (e: any) => {
      const isPushNotificationEnabled = await JSON.parse(e.data);

      if (isPushNotificationEnabled === true) {
        postMessageToRN({ messageKey: 'flarelane_subscribe', messageParam: 'true' });
      }
    };

    setRNMessageReceiver({ messageHandler: (e) => onMessageHandler(e) });

    postMessageToRN({ messageKey: 'permission', messageParam: 'push' });
  };

  const changeAdvertisementTermsAgreement = ({ isTurnOn }: { isTurnOn: boolean }) => {
    putUsersMe(
      {
        reqBody: {
          advertisementTermsAgreement: isTurnOn,
        },
      },
      {
        onSuccess: () => {
          if (isTurnOn && window.ReactNativeWebView) {
            requestPushAlarmPermission();
          }

          const resultText = isTurnOn ? '처리' : '철회';
          const message = `광고성 정보 수신 ${resultText} 요청이\n정상적으로 처리되었습니다.\n(${formatDate(
            new Date().toString(),
          )})`;
          openNotification({
            message,
          });
        },
      },
    );
  };

  const handleAdvertisementTermsAgreementClick = () => {
    if (userProfile?.advertisementTermsAgreement) {
      changeAdvertisementTermsAgreement({ isTurnOn: false });
    } else {
      changeAdvertisementTermsAgreement({ isTurnOn: true });
    }
  };

  if (userProfile) {
    return (
      <Container>
        <AlarmSettingsSection>
          <Box>
            <Title>{'광고성 정보 수신 동의'}</Title>

            <ToggleSwitch
              isChecked={userProfile?.advertisementTermsAgreement ?? false}
              onClick={handleAdvertisementTermsAgreementClick}
            />
          </Box>
        </AlarmSettingsSection>
      </Container>
    );
  }

  return <></>;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`;

const AlarmSettingsSection = styled.div`
  display: flex;
  padding: var(--radius-large, 16px) var(--radius-large, 16px) 32px var(--radius-large, 16px);
  flex-direction: column;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;
`;

const Title = styled.div`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 13.6px */
`;
